import React from "react";

export function useRefFor<T>(
  value: T,
  deps?: React.DependencyList,
): React.MutableRefObject<T | undefined> {
  const ref = React.useRef<T>(value);
  React.useEffect(
    () => {
      ref.current = value;
    },
    deps ?? [value],
  );
  return ref;
}
